<div *ngIf="branding$ | async as branding">
  <div class="dashboard-container flex justify-center bg-neutral-50 ng-star-inserted">
    <div class="grid-row mobile:px-5 tablet:px-6 laptop:w-912 desktop:px-0 py-5">
      <div class="flex-col content-center">
        <div class="items-center content-center mt-8">
          <img class="mx-auto items-center h-88" src="/assets/error-icon.svg" />
        </div>
        <div class="text-center mt-8">
          <span class="block font-medium text-5 text-dark">This request is no longer required</span>

          <span class="block mt-4 text-neutral-500 text-4">Feel free to close this browser window</span>
        </div>

        <div class="flex-col content-center mb-93 mt-93" *ngIf="webinarData && webinarData.length">
          <p class="text-center paragraph-2 block mt-4 text-neutral-500 text-4">Live & Interactive HR advice from Talos360 experts</p>

          <div class="grid grid-cols-1 tablet:grid-cols-3 gap-8 ml-5 mr-5 mt-4">

            <div
                 class="bg-light rounded rounded-top-0"
                 *ngFor="let webinar of webinarData; let i = index">

              <div class="rounded bg-neutral-50 flex-direction">
                <a
                   [href]="webinar.url"
                   [title]="webinar.title">
                  <img
                       class="rounded webinar-img"
                       width="1015"
                       height="571"
                       decoding="async"
                       loading="lazy"
                       [src]="webinar.image" />
                </a>

                <div class="webinar-panel text py-6 px-6 bg-light">
                  <a
                     [href]="webinar.url"
                     [title]="webinar.title">
                    <span class="text-4 font-medium text-dark">{{webinar.title}}</span>
                  </a>
                  <div class="row align-items-end" style=" margin-top: 10px;">
                    <div class="col-5 text-right">
                      <a class="flex items-center mt-1 group info-200 hover:info-200 text-4" [href]="webinar.url"><span class="text-4"> Watch Now</span><i aria-hidden="true" class="fak fa-talos-arrow-right font-semibold ml-1 group-hover:ml-2 transition-all"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
